/**
 * DOM contract between the Modal atom and `webflow-modal.js`.
 *
 * These live here rather than in `overlays/modal` because the published site
 * module's drift test checks its hand-copied literals against them, and
 * `core-constants` has no runtime dependencies of its own.
 */

/** Class on the modal's `<dialog>`. */
export const MODAL_CLASS = 'w-modal';

/** Class on a Link that opens or closes a modal. */
export const MODAL_TRIGGER_CLASS = 'w-modal-trigger';

/**
 * Marker the Modal atom writes when "Lock scrolling while open" is on.
 *
 * `webflow-modal.js` keeps wheel and touch scrolling inside a modal that
 * carries it while the modal is open, and bootflow gives it
 * `overscroll-behavior: contain`.
 */
export const MODAL_LOCK_SCROLL_ATTRIBUTE = 'data-w-modal-lock-scroll';

/**
 * Marker the `wf:modal` trigger writes onto a modal's `<dialog>` while bound,
 * saying this modal has an open/close animation. `webflow-modal.js` only holds
 * a close for a dialog that carries it.
 */
export const MODAL_ANIMATED_ATTRIBUTE = 'data-w-modal-animated';

/**
 * DOM event carrying a command *to* a modal, the Modal counterpart of
 * `POPOVER_COMMAND_EVENT`. `webflow-modal.js` listens for it.
 */
export const MODAL_COMMAND_EVENT = 'webflow:modal-command';

/**
 * Commit the modal open, or closed, WITHOUT animating. IX3 sends these when a
 * trigger other than the modal's own state change drives its Open or Close
 * timeline, so the receiver only does the DOM half (`showModal()` / `close()`)
 * and must not re-announce the state change.
 */
export const MODAL_ANIMATION_OPEN_COMMAND = 'animation-open';
export const MODAL_ANIMATION_CLOSE_COMMAND = 'animation-close';
